module.exports = __webpack_public_path__ + "img/desktop/Background/background@3x.jpg?0.0.53";